import { MoonIcon, SunIcon } from '@chakra-ui/icons';
import {
  ButtonProps,
  ChakraComponent,
  IconButton,
  useColorMode,
} from '@chakra-ui/react';

export const ColorModeButton = ((props: ButtonProps) => {
  const { colorMode, toggleColorMode } = useColorMode();

  let icon = <></>;

  if (colorMode === 'light') {
    icon = <SunIcon />;
  } else {
    icon = <MoonIcon />;
  }

  return (
    <IconButton
      {...props}
      aria-label="theme"
      icon={icon}
      onClick={toggleColorMode}
    ></IconButton>
  );
}) as ChakraComponent<'button', {}>;
